import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import CustomButton from "../../components/button";
import Spinner from "../../components/spinner/index"; // Import your spinner component

const EmailVerificationPage = () => {
  const { verificationToken } = useParams(); // Extract the token from the URL
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState(""); // 'success' or 'error'
  const [loading, setLoading] = useState(true); // State to handle spinner
  const navigate = useNavigate();

  useEffect(() => {
    // Display spinner for one second before verification starts
    const timer = setTimeout(() => {
      const verifyEmail = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_DEV_BACKEND_URL}/auth/verify-email/${verificationToken}`
          );
          setMessage(response.data.message);
          setStatus("success");
        } catch (error) {
          setMessage(
            error.response?.data?.message || "An error occurred during verification."
          );
          setStatus("error");
        } finally {
          setLoading(false); // Stop spinner after response
        }
      };

      verifyEmail();
    }, 1000);

    return () => clearTimeout(timer); // Cleanup timer on component unmount
  }, [verificationToken]);

  const handleReturnToLogin = () => {
    navigate("/login"); // Redirect to the login page
  };

  if (loading) {
    // Display spinner while loading
    return (
      <div style={styles.spinnerContainer}>
        <Spinner /> 
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {status === "success" ? (
        <>
          <FaCheckCircle style={{ ...styles.icon, color: "green" }} />
          <h1 style={styles.title}>Verification Successful!</h1>
          <h4> We will let you know once admin approve your request</h4>
        </>
      ) : (
        <>
          <FaTimesCircle style={{ ...styles.icon, color: "red" }} />
          <h1 style={styles.title}>Verification Failed</h1>
        </>
      )}
      <p style={styles.message}>{message}</p>
      <CustomButton variant="primary" onClick={handleReturnToLogin}>
        Return to Login
      </CustomButton>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    textAlign: "center",
    backgroundColor: "#f9f9f9",
    padding: "20px",
  },
  spinnerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f9f9f9",
  },
  icon: {
    fontSize: "5rem",
    marginBottom: "20px",
  },
  title: {
    fontSize: "2rem",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  message: {
    fontSize: "1.2rem",
    color: "#555",
    marginBottom: "20px",
  },
};

export default EmailVerificationPage;
